var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8848 18.2483C19.9375 18.2553 19.9901 18.2624 20.0428 18.2698L20.3084 18.3071C21.4651 18.4694 22.4999 17.5878 22.4999 16.4402V15.5643C22.4999 14.7435 21.9746 14.0114 21.1877 13.7353C20.2787 13.4164 19.3404 13.2088 18.3931 13.1124C19.3817 13.8272 19.9949 14.9846 19.9949 16.2473V17.3348C19.9949 17.6506 19.9566 17.9564 19.8848 18.2483ZM15.8773 11.9473C16.2712 12.1098 16.7038 12.1997 17.1578 12.1997C18.9851 12.1997 20.4664 10.7446 20.4664 8.94975C20.4664 7.15487 18.9851 5.69983 17.1578 5.69983C17.1039 5.69983 17.0503 5.7011 16.997 5.7036C17.3293 6.41129 17.515 7.20147 17.515 8.03502C17.515 9.56634 16.8883 10.9513 15.8773 11.9473Z",
    fill: "#D5DAE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11519 18.2483C4.06251 18.2553 4.00984 18.2624 3.9572 18.2698L3.69155 18.3071C2.53493 18.4694 1.50012 17.5878 1.50012 16.4402V15.5643C1.50012 14.7435 2.02541 14.0114 2.81233 13.7353C3.72126 13.4164 4.65962 13.2088 5.60686 13.1124C4.61828 13.8272 4.00512 14.9846 4.00512 16.2473V17.3348C4.00512 17.6506 4.04335 17.9564 4.11519 18.2483ZM8.12268 11.9473C7.7288 12.1098 7.29615 12.1997 6.84214 12.1997C5.01487 12.1997 3.53357 10.7446 3.53357 8.94975C3.53357 7.15487 5.01487 5.69983 6.84214 5.69983C6.89607 5.69983 6.94969 5.7011 7.00298 5.7036C6.67069 6.41129 6.48498 7.20147 6.48498 8.03502C6.48498 9.56634 7.11172 10.9513 8.12268 11.9473Z",
    fill: "#D5DAE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0571 8.03493C16.0571 5.8065 14.2506 4 12.0222 4C9.79375 4 7.98725 5.8065 7.98725 8.03493C7.98725 10.2634 9.79375 12.0699 12.0222 12.0699C14.2506 12.0699 16.0571 10.2634 16.0571 8.03493Z",
    fill: "#D5DAE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10769 13.9764C10.2857 12.8414 13.7586 12.8414 16.9367 13.9764C17.8964 14.3192 18.537 15.2282 18.537 16.2472V17.3347C18.537 18.7595 17.275 19.854 15.8644 19.6525L15.5405 19.6062C13.2068 19.2729 10.8376 19.2729 8.5039 19.6062L8.17993 19.6525C6.76939 19.854 5.5074 18.7595 5.5074 17.3347V16.2472C5.5074 15.2282 6.14801 14.3192 7.10769 13.9764Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.ab66211d1c36e9d733e34ce279afb72b.svg";
export { ForwardRef as ReactComponent };